export const COLORS = {
    primary: '#FF753A',
    primary_trans: '#FF753A99',
    secondary: '#2A9D8F',
    secondary_trans: '#2A9D8F99',
    tertiary: '#E9C46ABF',
    white: '#FFF',
    lightGrey: '#F6F6F6',
    grey: '#CCCCCC',
    darkGrey: '#373737',
};

export const PRESENTIS = {
    color: COLORS.primary,
    textTransform: 'uppercase',
    fontWeight: 'bold'
};

export const ROW = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
};

export const ROW_CENTER = {
    ...ROW,
    justifyContent: 'center'
};

export const ROW_SPACE_BETWEEN = {
    ...ROW,
    justifyContent: 'space-between'
};

export const ROW_SPACE_AROUND = {
    ...ROW,
    justifyContent: 'space-around'
};

export const ROW_END = {
    ...ROW,
    justifyContent: 'end'
};

const COLUMN = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
};

export const COLUMN_CENTER = {
    ...COLUMN,
    alignItems: 'center'
};

export const COLUMN_START = {
    ...COLUMN,
    alignItems: 'start'
};

export const SPACE = {
    extraSmall: '5px',
    small: '10px',
    medium: '15px',
    large: '20px',
    extraLarge: '25px'
};

export const INLINE_LINK = {
    display: 'inline',
    textDecoration: 'underline',
    color: COLORS.primary
};

export const INPUT = {
    width: '100%',
    height: '40px',
    border: `1px solid ${COLORS.grey}`,
    borderRadius: '5px',
    padding: SPACE.small,
    fontSize: '16px',
    backgroundColor: COLORS.white
};

export const FIELDSET = {
    border: `1px solid ${COLORS.darkGrey}`,
    borderRadius: '15px',
    padding: SPACE.large
};

export const LEGEND = {
    fontSize: '20px',
    border: `8px solid ${COLORS.white}`,
};

export const TITLE = {
    ...COLUMN_CENTER,
    width: '360px',
    height: '50px',
    borderRadius: '10px',
    boxShadow: `4px 4px 6px 0px ${COLORS.grey}`,
    marginBottom: SPACE.small
};

export const ELEMENT_BLOCK = {
    padding: SPACE.extraLarge,
    borderRadius: '5px',
    margin: 'auto',
    marginBottom: SPACE.medium,
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)'
};

export const ELEMENT_BLOCK_WHITE = {
    ...ELEMENT_BLOCK,
    backgroundColor: COLORS.white
};

export const ELEMENT_BLOCK_GREY = {
    ...ELEMENT_BLOCK,
    backgroundColor: COLORS.lightGrey
};